import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Suspense } from 'react';
import { TimeLazyLoad } from '../../../common/lazy-load-timing';
import { LoadingSpinner } from '../../../common/loading-spinner';
import { withProductContext } from '../product-router';
import { InitialisationExperienceSuccess } from './initialisation-experience-success';
import { ActiveProduct } from './active-product';
export var AsyncProductInner = /*#__PURE__*/function (_React$Component) {
  _inherits(AsyncProductInner, _React$Component);
  var _super = _createSuper(AsyncProductInner);
  function AsyncProductInner() {
    _classCallCheck(this, AsyncProductInner);
    return _super.apply(this, arguments);
  }
  _createClass(AsyncProductInner, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
        removeProduct = _this$props.removeProduct,
        id = _this$props.id;
      removeProduct(id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        FallbackComponent = _this$props2.fallback,
        id = _this$props2.id,
        children = _this$props2.children;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(ActiveProduct, {
          id: id
        }, /*#__PURE__*/React.createElement(TimeLazyLoad, {
          product: id
        }, FallbackComponent ? /*#__PURE__*/React.createElement(FallbackComponent, null) : /*#__PURE__*/React.createElement(LoadingSpinner, null)))
      }, /*#__PURE__*/React.createElement(InitialisationExperienceSuccess, this.props), children);
    }
  }]);
  return AsyncProductInner;
}(React.Component);

/**
 * A component to register the product with a product router and asyncronously load its contents
 */
export var AsyncProduct = withProductContext(AsyncProductInner);